// @flow

import View from 'components/View';
import * as React from 'react';

const styles = {
  box: {
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'visible !important'
  },
  layout: {
    flexDirection: 'column',
    flexGrow: 1
  }
};

const FocusContent = ({ children, style }) => (
  <View style={styles.layout}>
    <View suppressScrollX="false" style={[styles.box, style]}>
      {children}
    </View>
  </View>
);

export default FocusContent;
